module.exports = __webpack_public_path__ + "img/fullLogo.f444880e.png";